module.exports = {
      id: "libra-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#libra",
      toString: function () {
        return this.url;
      }
    }